import React from "react";
import { useCallback } from "react";
import { Toggle } from "@/components/ui/toggle";
import { cn } from "@/lib/utils";
import { Play } from "lucide-react";

interface AnimatedToggleProps {
  isOn?: boolean;
  onChange?: (isOn: boolean) => void;
  icon?: React.ReactNode;
  className?: string;
  dataTooltipContent?: string;
  dataTooltipId?: string;
  disabled?: boolean;
}

export const AnimatedToggle = ({
  isOn = false,
  onChange,
  icon,
  className,
  dataTooltipContent,
  dataTooltipId,
  disabled = false,
}: AnimatedToggleProps) => {
  const handlePress = useCallback(() => {
    if (disabled) return;
    onChange?.(!isOn);
  }, [isOn, onChange, disabled]);

  return (
    <Toggle
      pressed={isOn}
      onPressedChange={handlePress}
      data-tooltip-content={dataTooltipContent}
      data-tooltip-id={dataTooltipId}
      className={cn(
        "relative bg-muted h-[20px] w-[34px] transition-colors duration-200 rounded-[5px] select-none hover:text-white",
        isOn ? "data-[state=on]:bg-primary-n-800" : "bg-background-secondary",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
    >
      <div
        className={
          cn(
            "absolute left-[1px] top-[1px] h-[18px] w-[19px] bg-background transition-transform duration-200",
            isOn && "translate-x-[13px] bg-background-CTA text-white",
            !isOn && "bg-secondary-n-800 hover:text-white",
            disabled && (isOn ? "bg-opacity-50" : "bg-opacity-50")
          ) + " rounded"
        }
      >
        {icon || (
          <Play className="absolute w-[11px] h-[11px] top-[3.5px] left-[4px]" />
        )}
      </div>
    </Toggle>
  );
};

export default AnimatedToggle;
